import MuiPaper, { PaperProps } from '@mui/material/Paper';

function Paper(props: PaperProps) {
  return <MuiPaper {...props} />;
}

export default Paper;
